<form #formRef="ngForm">
	<bb-page-header [icon]="'gavel'" [title]="'GLOBAL_PREBID_SETTINGS' | translate" [tabItems]="tabItems" [inModal]="route?.outlet === 'modal'">
	</bb-page-header>

	<div class="body-column tab-container">
		<span *ngIf="activeTab === 'auction'" class="message info">{{ 'INFO.GLOBAL_PREBID_AUCTION_SETTINGS' | translate }}</span>
		<span *ngIf="activeTab === 'modules'" class="message info">{{ 'INFO.GLOBAL_PREBID_MODULES_SETTINGS' | translate }}</span>
		<span *ngIf="activeTab === 'adapters'" class="message info">{{ 'INFO.GLOBAL_PREBID_ADAPTERS_SETTINGS' | translate }}</span>

		<bb-auction-settings *ngIf="activeTab === 'auction'" [form]="form" [config]="publicationPrebidParams?.__config__" [publicationMode]="true"></bb-auction-settings>
		<ng-container *ngIf="activeTab === 'modules' || activeTab === 'adapters'">
			<bb-prebid-fields mode="card" [typeFilter]="activeTab === 'modules' ? 'module' : 'adapter'" *ngIf="publicationPrebidParams" [prebidParams]="publicationPrebidParams" [filterParams]="null" (change)="prebidParamsChanged()"></bb-prebid-fields>
		</ng-container>
	</div>
</form>

<bb-actions-bar (onSave)="save()" (onCancel)="cancel()" [form]="form" [entity]="publicationPrebidParams"></bb-actions-bar>
